import { HostListener, Injectable, OnDestroy } from '@angular/core';
import { Util } from '@phdsoft/common';
import { AssetManager, FunctionalityMode } from './asset-manager';
import { GraphicsMaterials } from '../digital-twin/graphics/graphics-materials';
import { v4 as uuid } from 'uuid';
import { Graphics } from '../digital-twin/graphics/graphics';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import * as THREE from '@phdsoft/three';
import { Vector3 } from '@phdsoft/three';
import { GraphicsRenderCriticalArea } from '../digital-twin/graphics/graphics-render-critical-area';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AssetManagerFilter } from './asset-manager-filter';
import { RepairService } from '../shared/services/repair.service';
import { WeightTemporalElementsCampaign } from '../platform/busines-data/Campaigns/WeightTemporalElementsCampaign';
import { WeightAreaElement } from '../platform/busines-data/SectionElements/TemporalElements/WeightAreaElement';
@Injectable({ providedIn: 'root' })
export class AssetManagerBoxMeasureTool implements OnDestroy {
  currentWeightTemporalElementsCampaign: WeightTemporalElementsCampaign;

  //#region Centralized getters/setters using asset-manager
  private get functionalityMode(): FunctionalityMode {
    return this.assetManager.functionalityMode;
  }

  private set functionalityMode(value: FunctionalityMode) {
    this.assetManager.functionalityMode = value;
  }

  private get elementTypeForInsertionAndSelectionGuid(): string {
    return this.assetManager.elementTypeForInsertionAndSelectionGuid;
  }

  private _spherePointsGroup : THREE.Group;
  public get spherePointsGroup() : THREE.Group {
    return this._spherePointsGroup;
  }
  public set spherePointsGroup(v : THREE.Group) {
    this._spherePointsGroup = v;
  }


  private _boxMeasure : THREE.Mesh;
  public get boxMeasure() : THREE.Mesh {
    return this._boxMeasure;
  }
  public set boxMeasure(v : THREE.Mesh) {
    this._boxMeasure = v;
  }

  private _boxMeshesGroup : THREE.Group;
  public get boxMeshesGroup() : THREE.Group {
    return this._boxMeshesGroup;
  }
  public set boxMeshesGroup(v : THREE.Group) {
    this._boxMeshesGroup = v;
  }
  private _regionIds : Array<string>;
  public get regionIds() : Array<string> {
    return this._regionIds;
  }
  public set regionIds(v : Array<string>) {
    this._regionIds = v;
  }

  private _width : THREE.Mesh;
  public get width() : THREE.Mesh {
    return this._width;
  }
  public set width(v : THREE.Mesh) {
    this._width = v;
  }

  private _height : THREE.Mesh;
  public get height() : THREE.Mesh {
    return this._height;
  }
  public set height(v : THREE.Mesh) {
    this._height = v;
  }

  private _depth : THREE.Mesh;
  public get depth() : THREE.Mesh {
    return this._depth;
  }
  public set depth(v : THREE.Mesh) {
    this._depth = v;
  }

  public isActive:boolean=false;
  private isComputing:boolean=false;
  //#endregion

  constructor(
    private graphicsRenderCriticalArea: GraphicsRenderCriticalArea,
    private graphics: Graphics,
    private assetManager: AssetManager,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public assetManagerFilter: AssetManagerFilter,
    private repairService: RepairService,
  ) {

  }

  @HostListener('unloaded')
  ngOnDestroy(): void {
    console.log('💣 Destroy AssetManagerBoxMeasureTool');
  }

  addNewProtectionElementCollection(date: Date, sphereGroup:THREE.Group, boxGroup:THREE.Group) {
    let _newCollection = new WeightTemporalElementsCampaign(date, null, sphereGroup, boxGroup)
    this.assetManager.asset.addWeightTemporalElementsCollection(_newCollection)
    this.currentWeightTemporalElementsCampaign = _newCollection
    return _newCollection
  }

  public startWeightMeasurementToolMode(): void {

    if(Util.isNullOrUndefined(this._spherePointsGroup))
      this._spherePointsGroup = new THREE.Group();
    if(Util.isNullOrUndefined(this._boxMeshesGroup))
      this._boxMeshesGroup = new THREE.Group();

    if(Util.isNullOrUndefined(this.assetManager.asset.WeightTemporalElementsCampaign)){
      this.addNewProtectionElementCollection(this.assetManager.referenceDate, this._spherePointsGroup, this._boxMeshesGroup);
    }

    // if(this._spherePointsGroup.parent == null){
    //   this.graphics.scene.add(this._spherePointsGroup);
    // }

    // if(this._boxMeshesGroup.parent == null){
    //   this.graphics.scene.add(this._boxMeshesGroup);
    // }
    this.isActive = true;
    this.functionalityMode = 'BOXWEIGHTTOOL';
    // if (Util.isNullOrUndefined(this.graphics.currentSection)) {
    //   if (this.graphics.sectionNavigator.length === 1) {
    //     this.graphics.currentSection = this.graphics.sectionNavigator[0];
    //   }
    // }
    // this.graphics.Controls.enableRotate = false
    this.graphics.hammerManager.get('pan').set({ enable: true });
    // this.graphicsRender.controls.enableRotate = false;
    this.snackBar.open('Tap to insert points.', '', {
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        duration: 7000
      });
  }

  public cancelWeightMeasurementToolMode(){
    // this.graphics.scene.remove(this._spherePointsGroup);
    // this.graphics.scene.remove(this._boxMeshesGroup);
    this.disposeGroup();
    for (let index = this.boxMeshesGroup.children.length-1; index >= 0; index--) {
      const element = this.boxMeshesGroup.children[index];
      this.boxMeshesGroup.remove(element);
      (element as THREE.Mesh).geometry.dispose()
    }

    GraphicsMaterials.basicMaterial.opacity = GraphicsMaterials.opacityLevel
    GraphicsMaterials.syncLightSectionMaskMaterials();
  }

  public clearWeightMeasurementToolMode(){
    // this.graphics.scene.remove(this.spherePointsGroup);
    this.disposeGroup();
  }

  public stopWeightMeasurementToolMode(){
    this.isActive = false;
  }

  public async computeBoxAndWeightMeasurementToolMode(){
    try {
      const box3 = new THREE.Box3();
      let points: Vector3[] = [];
      for (const element of this.spherePointsGroup.children) {
        var position = element.position;
        points.push(position);
      }

      box3.setFromPoints(points);


      // make a BoxGeometry of the same size as Box3
      const dimensions = new THREE.Vector3().subVectors( box3.max, box3.min );
      const boxGeo = new THREE.BoxGeometry(dimensions.x, dimensions.y, dimensions.z);

      // move new mesh center so it's aligned with the original object
      const matrix = new THREE.Matrix4().setPosition(dimensions.addVectors(box3.min, box3.max).multiplyScalar( 0.5 ));
      boxGeo.applyMatrix4(matrix);

      console.log(this.assetManager.asset.lightCampaign.Elements)
      console.log(this.assetManager.asset.lightCampaign)
      console.log(this.assetManager.asset)
      this.regionIds = []
      for (const region of this.assetManager.asset.lightCampaign.regionsWorkableElements) {
        if(region.visible){
          if(!Util.isNullOrUndefined(region.surfaceElements) && region.surfaceElements.length > 0){
            var intersect = box3.clone().intersectsBox(region.surfaceElements[0].SurfaceDesign.geometry.boundingBox);

            if(intersect)
              this.regionIds.push(region.Guid)
          }
        }
      }
      GraphicsMaterials.basicMaterial.opacity = 0.5
      GraphicsMaterials.syncLightSectionMaskMaterials();

      // make a mesh
      // if(this.boxMeasure != null){
      //   this.boxMeshesGroup.remove(this.boxMeasure);
      // }

      // this.boxMeasure = new THREE.Mesh(boxGeo, GraphicsMaterials.criticalAreaBoxMaterial);
      // this.boxMeasure.geometry.computeBoundingBox();
      // this.boxMeshesGroup.add(this.boxMeasure);

      let boxMeasure = new THREE.Mesh(boxGeo, GraphicsMaterials.criticalAreaBoxMaterial);
      boxMeasure.geometry.computeBoundingBox();

      this.boxMeshesGroup.add(boxMeasure);

      // this.createLabels(this.boxMeasure, dimensions.x, dimensions.z, dimensions.y);
      this.isComputing = true;
      let res = await this.repairService.GenerateWeightMeasureBox(box3.min.x, box3.max.x, box3.min.y, box3.max.y, box3.min.z, box3.max.z,
        this.assetManager.asset.assetInfo.AssetId, this.regionIds);

      if(res && this.assetManager.functionalityMode === 'BOXWEIGHTTOOL'){
        let totalWeight = 0;
        let geometries = []
        for (const element of res) {
          totalWeight += element.weight;

          const geometry = new THREE.BufferGeometry();
          if (!element.vertices) continue;

          geometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(element.vertices), 3));

          if (element.faces && element.faces.length > 0) geometry.setIndex(element.faces);

          geometry.computeVertexNormals();
          geometry.computeBoundingBox();
          geometries.push(geometry);
          // this.boxMeshesGroup.add(_mesh);
        }

    var mergedGeometry = mergeGeometries(geometries);
        mergedGeometry.computeBoundingBox();
        mergedGeometry.computeVertexNormals();

        const _mesh = new THREE.Mesh(mergedGeometry, GraphicsMaterials.blueMaterial);

        let weightAreaElement = new WeightAreaElement(uuid(),_mesh,  GraphicsMaterials.blueMaterial, "", "", totalWeight);

        this.currentWeightTemporalElementsCampaign.addModelTemporalElement(weightAreaElement);

        console.log(totalWeight);

        boxMeasure.geometry.dispose();
        this.boxMeshesGroup.remove(boxMeasure);
        this.snackBar.open('Total Weight => '+(totalWeight*0.001).toFixed(1)+' tons', '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 15000
        });

      }
    } catch (error) {
      this.isComputing = true;
      console.log(error)
    }
  }


  private createLabels(box: THREE.Mesh, width:number, depth:number, height:number){
    const loader = new FontLoader();
    loader.load(
        'statics/fonts/nucleo/helvetiker_bold.typeface.json', (myFont) => {
            let textLabeldepht = new TextGeometry(width.toFixed(1), {
                font: myFont,
                size: 0.1,
                depth: 0.02,
            });
            let textLabelwidth = new TextGeometry(depth.toFixed(1), {
                font: myFont,
                size: 0.1,
                depth: 0.02,
            });
            let textLabelHeight = new TextGeometry(height.toFixed(1), {
                font: myFont,
                size: 0.1,
                depth: 0.02,
            });


            //let centerNorth = new THREE.Vector3();
            //let geoNorth = new THREE.BufferGeometry();

            this._depth = new THREE.Mesh(textLabeldepht, GraphicsMaterials.axisBoxLabelMaterial);
            this.width = new THREE.Mesh(textLabelwidth, GraphicsMaterials.axisBoxLabelMaterial);
            this.height = new THREE.Mesh(textLabelHeight, GraphicsMaterials.axisBoxLabelMaterial);

            //this.meshNorth.geometry.computeBoundingBox();

            //centerNorth = this.meshNorth.geometry.boundingBox.getCenter(centerNorth);
            this._depth.geometry.center()
            this.width.geometry.center()
            this.height.geometry.center()


            this._depth.name = "North"
            this.width.name = "South"
            this.height.name = "East"

            this._depth.visible = true
            this.width.visible = true
            this.height.visible = true

            this._depth.userData.scale = 1;
            this.width.userData.scale = 1;
            this.height.userData.scale = 1;

            this._depth.up.set(0, 0, 1);
            this.width.up.set(0, 0, 1);
            this.height.up.set(0, 0, 1);

            this._depth.rotation.set(Math.PI / 2, Math.PI / 2, 0);
            this.width.rotation.set(Math.PI / 2, -Math.PI / 2, 0);
            this.height.rotation.set(Math.PI / 2, 0, 0);

            debugger

            const boundingBox = box.geometry.boundingBox;
            const min = boundingBox.min;  // Vector3 with min X, Y, Z
            const max = boundingBox.max;  // Vector3 with max X, Y, Z

            // Calculate label positions based on the bounding box
            const widthLabelPosition = new THREE.Vector3((min.x + max.x) / 2, min.y, max.z);  // Width label position
            const heightLabelPosition = new THREE.Vector3(max.x, (min.y + max.y) / 2, max.z); // Height label position
            const depthLabelPosition = new THREE.Vector3(max.x, min.y, (min.z + max.z) / 2);  // Depth label position

            const labelPositionw = new THREE.Vector3(width / 2, box.position.y, box.position.z); // Adjust for the edge you want to label
            this.width.position.copy(widthLabelPosition);


            const labelPositiond = new THREE.Vector3(depth / 2, box.position.y, box.position.z); // Adjust for the edge you want to label
            this.depth.position.copy(depthLabelPosition);

            const labelPositionh = new THREE.Vector3(height / 2, box.position.y, box.position.z); // Adjust for the edge you want to label
            this.height.position.copy(heightLabelPosition);
            // this._depth.position.set(box.position);
            // this.width.position.set(-200, 0, -100);
            // this.height.position.set(0, -200, -100);

            //centerNorth.add(new THREE.Vector3(200, -60, 120))

            // var vector = new THREE.Vector3(0, 0, -1);
            // vector.applyQuaternion(this.axesCamera.quaternion);
            // this.axesCamera.getWorldDirection(vector);



            // this.meshSouth.lookAt(this.axesCamera.position );
            // this.meshNorth.lookAt(this.axesCamera.position );
            // this.meshEast.lookAt(this.axesCamera.position );
            // this.meshWest.lookAt(this.axesCamera.position );



            // this.meshNorth.lookAt(vector.clone())
            // this.meshSouth.lookAt(vector.clone())
            // this.meshEast.lookAt(vector.clone())
            // this.meshWest.lookAt(vector.clone())


            this.graphics.scene.add(this.width)
            this.graphics.scene.add(this.depth)
            this.graphics.scene.add(this.height)

        });
  }

  public StartWeightMeasurementPointInsertion(ev, regionId: string): void {
    if(!this.isActive)
      return;
    if(this.isComputing)
    {
      // this.snackBar.open('Please wait while we finish computing => ', '', {
      //   horizontalPosition: 'center',
      //   verticalPosition: 'top',
      //   duration: 2000
      // });
      // return
    }
    if (this.functionalityMode === 'BOXWEIGHTTOOL') {
      this.insertWeightAreaBox(ev, regionId)
      if(Util.isNullOrUndefined(this.regionIds))
        this.regionIds = []
      if(!this.regionIds.includes(regionId))
        this._regionIds.push(regionId);

      if(this.spherePointsGroup.children.length === 3){
        this.computeBoxAndWeightMeasurementToolMode();
        this.clearWeightMeasurementToolMode();
      }
    }
  }

  private disposeGroup(){
    for (let index = this._spherePointsGroup.children.length-1; index >= 0; index--) {
      const element = this._spherePointsGroup.children[index];
      this.spherePointsGroup.remove(element);
      (element as THREE.Mesh).geometry.dispose()
    }
    // this.spherePointsGroup.children = []
  }

  private async insertWeightAreaBox(ev, sectionId: string) {
    let spherePoint = this.graphicsRenderCriticalArea.createPointOnPosition(ev, this.assetManager.asset, sectionId);

    this._spherePointsGroup.add(spherePoint);

    // const dialogRef = this.dialog.open(CriticalAreaBoxConfigComponent, {
    //   panelClass: 'transparentModal',
    //   hasBackdrop: false,
    // });

    // dialogRef.afterClosed().subscribe((dimensions: Vector3) => {
    //   if (dimensions) {
    //     this.prepareToGenerateCriticalAreaByVolume(this.criticalAreaBox.position, dimensions)
    //     this.criticalAreaBox = null
    //   }
    //   else {
    //     this.criticalAreaBox = null
    //   }
    // });
  }
}
